import { render, staticRenderFns } from "./Pd2.vue?vue&type=template&id=5f827cbc&scoped=true"
import script from "./Pd2.vue?vue&type=script&lang=js"
export * from "./Pd2.vue?vue&type=script&lang=js"
import style0 from "./Pd2.vue?vue&type=style&index=0&id=5f827cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f827cbc",
  null
  
)

export default component.exports